import AdminEleven from "@/layouts/AdminEleven.vue";

export const salesRoutes = [
  {
    path: "/vendas",
    component: AdminEleven,
    props: {
      withSearchInput: false,
    },
    children: [
      {
        name: "sales",
        path: "",
        component: () =>
          import(/* webpackChunkName: "about" */ "@/views/sales/Sales.vue"),
        meta: {
          title: "Vendas",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "discountCoupon",
        path: "/cupom-desconto",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/DiscountCoupon.vue"
          ),
        meta: {
          title: "Cupom de Desconto",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "discountCouponSettings",
        path: "/cupom-desconto/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/DiscountCouponSettings.vue"
          ),
        meta: {
          title: "Cupom de Desconto",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "ticketPackage",
        path: "/pacote-ingresso",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/TicketPackage.vue"
          ),
        meta: {
          title: "Pacote de Desconto",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "afilliatesProgram",
        path: "/programa-afiliados",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/AffiliatesProgram.vue"
          ),
        meta: {
          title: "Rede de Afiliados",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "afilliatesProgramSettings",
        path: "/programa-afiliados/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/AffiliatesProgramSettings.vue"
          ),
        meta: {
          title: "Rede de Afiliados",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salePoint",
        path: "/ponto-de-venda",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/SalesPoint.vue"
          ),
        meta: {
          title: "Ponto de Venda",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salePointSettings",
        path: "/ponto-de-venda/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/SalesPointSettings.vue"
          ),
        meta: {
          title: "Ponto de Venda",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "salePointType",
        path: "/tipos-ponto-de-venda",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/SalesPointType.vue"
          ),
        meta: {
          title: "Tipos Ponto de Venda",
          requiresAuth: false,
          requiresAdminProfile: true,
        },
      },
      {
        name: "equipments",
        path: "/equipamentos",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/Equipments.vue"
          ),
        meta: {
          title: "Operações/Equipamentos",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
      {
        name: "equipmentsSettings",
        path: "/equipamentos/:type",
        component: () =>
          import(
            /* webpackChunkName: "about" */ "@/views/sales/EquipmentsSettings.vue"
          ),
        meta: {
          title: "Operações/Equipamentos",
          requiresAuth: true,
          requiresAdminProfile: true,
        },
      },
    ],
  },
];
